import { ChangeDetectorRef, Component, EventEmitter, HostListener, OnInit, Output, Renderer2 } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { FileInfoActivityComponent } from '@common-standalone/file-operations/file-info-activity/file-info-activity.component';
import { FileInfoCommentsComponent } from '@common-standalone/file-operations/file-info-comments/file-info-comments.component';
import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { FileOperationsController } from '@commoncore/controller/FileOperationsController';
import { ShareObjectsController } from '@commoncore/controller/ShareObjectsController';
import { UserloginController } from '@commoncore/controller/UserLoginController';
import { ShareObjectsImplementation } from '@commoncore/implementation/ShareObjectsImplementation';
import { CleverTapEventsService } from '@commoncore/services/clevertap-events-service';
import { ContextMenuMobileService } from '@commoncore/services/context-menu-mobile.service';
import { GlobalService } from '@commoncore/services/global.service';
import { ListService } from '@commoncore/services/list.service';
import { LocalStorageSvc } from '@commoncore/services/localStorage.service';
import { LoggerService } from '@commoncore/services/logger.service';
import { UniversalService } from '@commoncore/services/universal.service';
import { AppEvents, EventsList } from '@commoncore/utils/app-events';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { USER_DETAILS } from '@mainrepo/app/core/constants/Constants';
import { DependenciesModule } from '@modules/dependencies/dependencies.module';


declare var jQuery: any;


@Component({
  standalone:true,
  selector: 'lib-file-info',
  templateUrl: './file-info.component.html',
  styleUrls: ['./file-info.component.scss'],
  imports:[DependenciesModule,FileInfoActivityComponent,FileInfoCommentsComponent]
})

export class FileInfoComponent implements OnInit {
  public objectKind;
  public fileInfoUrl;
  public infoItems = [];
  public defaultContent :any;
  public fileOperationsCntlr: FileOperationsController;
  public fileRename = new FormGroup({
    fileName: new FormControl(""),
    fileExtn: new FormControl("")
  });
  renameError: string = "";
  enableButton:boolean = false;
  editKeyPressCount:number = 0;
  @Output() fileRenamed = new EventEmitter()

  fileInfoController: any;
  shareObjectsImplementation: any;
  public sharedFileRecipientsList:any;
  public sharedWithNamesLink:any;
  public router:any;
  public canUserEditName:boolean;
  userLoginController: any;
  loginImplRef: any;
  localStorageService: any;
  shareAccessService: any;
  showFileInfo:boolean = false;
  contextMenuService: any;
  cleverTapEventsService: CleverTapEventsService;
  show = false;
  buttonAdded: boolean = false;
  http:any;
  isEventTriggered:boolean = false;
  ppfToken:any =''
  openSourceComponent:any = "";
  Imgerr:boolean = false;
  constructor(
    private renderer: Renderer2,
    private globalService: GlobalService,
    public universalService:UniversalService,
    public listService:ListService,
    private localStorageSvc: LocalStorageSvc,
    public loggerService:LoggerService,
    private changeDetector:ChangeDetectorRef,
    public contextMenuMobileService:ContextMenuMobileService,) { 
    this.fileOperationsCntlr = FileOperationsController.getInstance(globalService);
    this.shareObjectsImplementation = ShareObjectsImplementation.getInstance(this.globalService)
    this.router = this.globalService.getRouterRef()
    this.setEnvObjects(this.globalService);
    }
  get fileName(){
    return this.fileRename.get('fileName');
  }

  get fileExtn(){
    return this.fileRename.get('fileExtn');
  }

  handleBgColor(event){
    //backGroundColor
    let el = $(event.target).closest('div.imgThumbnailCont');
    if(el.hasClass('backGroundColor')){
      el.removeClass('backGroundColor');
    }
  }
  onClickedOutside() {
    this.universalService.showMobFileInfoPanel = false;
    this.universalService.selectedNodes = [];
    this.universalService.clearSelection();
  }

  ngOnInit() {
    this.userLoginController = UserloginController.getInstance(this.globalService)
    this.loginImplRef = this.userLoginController.userLoginImplementation;
    this.checkIfUserIsLoggedIn();

    let classRef = this;

    AppEvents.optionSelected.subscribe(event => {
      if(event["fileInfo"]){
        if(event["openSource"] == "fileinfo"){
          this.openSourceComponent = event["openSource"];
        }
        classRef.showFileInfo = true;
        classRef.universalService.showFileInfo = true;
        // classRef.universalService.showTopMoreOptionsOnMobile = false;
        AppEvents.removeAllEventListener(EventsList.UPDATE_CONTEXT_MENU_ITEMS)
        this.registerEvents()
        classRef.resetProps();
        classRef.initializeComponent();
        classRef.changeDetector.detectChanges()
      } else if(event["closeAll"] || event["fileInfo"]==false){
        classRef.closeShowInfoModal();
        classRef.showFileInfo = false;
        classRef.universalService.showFileInfo = false;
        classRef.universalService.showInfoComments = false;
        this.openSourceComponent = "";
        classRef.changeDetector.detectChanges()
      }
    })
  }

  ngOnDestroy(){
    jQuery("[class*='modal-backdrop']").remove();
    this.isEventTriggered = false;
  }

  ngAfterViewInIt(){
    setTimeout(()=>{
      this.setInfoItemcontHeight();
    },300);
  }

  registerEvents(){
    let classRef = this;
    AppEvents.on(EventsList.UPDATE_CONTEXT_MENU_ITEMS, function(){
      classRef.universalService.showMobFileInfoPanel = false;
      classRef.contextMenuMobileService.decideContextMenuItemsForMobile();
    })
  }
  resetProps(){

    this.fileInfoUrl = "";
    if(!this.universalService.isMobileDevice){
      const img_wrapper = document.getElementById('desk-info-img-wrapper');
      if(img_wrapper){
        const imgThumbnailCont = (img_wrapper.querySelector('.imgThumbnailCont')as any);
        if(imgThumbnailCont)
        imgThumbnailCont.style.display="block";
      }
    } else {
       const mobileImgThumbnailCont = document.querySelector('.mobThumbnailCont')as any;
       if(mobileImgThumbnailCont)
       mobileImgThumbnailCont.style.display="block";
    }
   
  }
  
  publicLinknotLoggedIn:boolean = false
  async initializeComponent(){
    await this.getPPFToken()
    this.publicLinknotLoggedIn = false
    if(window.location.href.includes("?u")){
      this.publicLinknotLoggedIn = true;
      this.canUserEditName = false;
    }
    var format ='';
    if(this.universalService.selectedFile["format"])
    format =  this.universalService.selectedFile["format"].substring(0,1).toUpperCase()+this.universalService.selectedFile["format"].substring(1);
  
    if(!this.publicLinknotLoggedIn){

      this.fileInfoController = ShareObjectsController.getInstance(this.globalService);
      this.fileInfoController.setEnvObjects(this.globalService);

    }

   

    if(!this.universalService.showMobFileInfoPanel){
      this.getFileInfoImageUrl();
      this.openNav();
      if(this.universalService.selectedFile.isBackupDevices == 'Y'){
        this.defaultContent = this.universalService.FileInfo["Default_Icon_Content"]["BackupDeviceInfo"];
      }else{
        this.defaultContent = this.universalService.FileInfo["Default_Icon_Content"][format];
      }
    } else{
      if(this.universalService.selectedFile.objectType != "FR" && this.universalService.selectedFile.objectType != "BR") {
        this.getFileInfoImageUrl();
      }
      this.defaultContent = this.universalService.FileInfo["Default_Icon_Mobile_Content"][format];
    }
    this.defaultContent = (this.universalService.selectedFile["format"] == "Document" || this.universalService.selectedFile["format"] == "SpreadSheet" || this.universalService.selectedFile["format"] == "Presentation" || this.universalService.selectedFile["format"] == "MSOfficeDocument") ? "" : this.defaultContent;
    this.setObjectKind();
    this.setFileInfoData();
    if(this.universalService.selectedFile.hasOwnProperty('editName')){
      
      this.universalService.selectedFile["editName"] = false;
    }
    this.checkRenameRight();
    this.cleverTapEventsService.onShareFileInfo(this.universalService.currentTab);
    setTimeout(() => {
      $('.file-info-scrollable').scrollTop(0);
      $('.modal-body').scrollTop(0);
    }, 10);
    if(this.universalService.selectedFile?.isBackeupItem || this.universalService.selectedFile?.isBackupDevices == 'Y'){
      this.canUserEditName = false;
    }
  }
  checkRenameRight() {
    if(this.universalService.selectedFile.shareKey != undefined) {
      if(this.universalService.selectedFile.tfKey) {
        if(this.universalService.selectedFile.userRight && this.universalService.selectedFile.userRight.canRename == true) {
          this.canUserEditName = true;
        } else {
          this.canUserEditName = false;
        }
      } else {
        if(this.universalService.selectedFile.recipientsObjRights && this.universalService.selectedFile.recipientsObjRights.canRename == true) {
          this.canUserEditName = true;
        } else {
          this.canUserEditName = false;
        }
      }
    } else {
      if(this.router.url.indexOf('/albums') > -1){
        // if the user is file owner or album owner
        if(this.universalService.selectedFile["isLoggedInUsrFileOwner"] == true){
          this.canUserEditName = true;
        } else {
          this.canUserEditName = false;
        }
      } else if(((this.universalService.selectedTab == 'teamfolders' || this.router.url.includes("search/tf")) && this.universalService.currentTeamFolder["roleCode"] == "V") || (this.universalService.inAppWebViewOpened && !this.universalService.selectedFile["userRight"]["canRename"]) || this.universalService.selectedTab == 'JioPhoneCall AI'){
        this.canUserEditName = false;
      } else {
        this.canUserEditName = true;
      }
    }
  }



  setEnvObjects(globalService){
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.shareAccessService = this.globalService.getShareAccessServiceRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.contextMenuService = this.globalService.getContextMenuServiceRef();
    this.http = this.globalService.getHttpClientRef();

    setTimeout(() => {
      $('.modal-body').scrollTop(0);
    }, 10);
  }

  openNav() {
    if(!this.universalService.isMobileDevice || (this.universalService.isMobileDevice && !this.router.url.includes('/albums/'))) {
      document.getElementById("mySidenav").style.right = "0";
    }
  }

  closeShowInfoModal(){
    this.buttonAdded= false;
    this.fileExtn.setValue('');
    var el = document.getElementById("showMoreLessBtn");
    if(el){
      el.remove()
    }  
    this.universalService.disableModalBackdrop();
    //Set details active
    jQuery("#fileinfo-item-1").prop("checked", true);
    if((!this.universalService.isMobileDevice && !window.location.href.includes('/enterprise/'))|| (this.universalService.isMobileDevice && !this.router.url.includes('/albums/') && !window.location.href.includes('/enterprise/'))) {
      document.getElementById("mySidenav").style.right = "-1000px";
    }
    this.renameError = "";

  }

  closeNav() {
    this.fileExtn.setValue('');
    if(this.universalService.inAppWebViewOpened && this.universalService.currentTab == 'fileinfo') {
      this.listService.objectDetails["operationType"] = "fileinfo";
      this.listService.informAndroidAndIOSToCloseWebView("");
    } else {
      if(this.universalService.isMobileDevice){
        this.contextMenuService.decideContextMenuItems();
        this.universalService.showTopMoreOptionsOnMobile = true;
        if(!this.universalService.showPreview){
          this.universalService.selectedNodes = [];
        }
      }
      this.universalService.showFileInfo = false;
      this.universalService.disableModalBackdrop();
      AppEvents.optionSelected.next({fileInfo: false});
      if(this.universalService.selectedFile.hasOwnProperty('editName')){
        this.universalService.selectedFile["editName"] = false;
      }
      this.listService.deSelectAll(null);
   }
 }


  setObjectKind() {
    var file = this.universalService.selectedFile;
    if (file["format"] == "Document" || file["format"] == "SpreadSheet" || file["format"] == "Presentation" || file["format"] == 'MSOfficeDocument') {
      this.objectKind = "Microsoft" + " ( " + file["format"] + " )"
    } else if (file["format"] == "Folder") {
      this.objectKind = "Folder"
    } else if (file["format"] == "PDF") {
      this.objectKind = "Adobe" + "  ( " + file["format"] + " )"
    } else if (file["format"] == "text") {
      this.objectKind = "text" + " ( " + file["mimeSubType"] + " )";
    } else {
      this.objectKind = file["mimeType"] + " ( " + file["mimeSubType"] + " )";
    }
    this.universalService.selectedFile["objectKind"] = this.objectKind;
  }

  getFileInfoImageUrl(){
    if(this.universalService.selectedFile["previewTranscodeUrl"] != undefined) {
      const  operator = this.universalService.selectedFile["previewTranscodeUrl"].includes('?') ? '&' : '?';
      let type = this.universalService.checkIfImgTypeParamIsRequired(this.universalService.selectedFile["mimeSubType"]);
      let url = this.universalService.selectedFile["previewTranscodeUrl"]+ operator + "size=c&apiKey="+ENV_CONSTANTS.envHeaders[GlobalClassInstance.ENV_NAME]["X-Api-Key"] + "&devicetype=web" + type;
      if(this.router.url.includes("privatefolder")){
        this.fileInfoUrl = url + '&ppftoken='+this.ppfToken;
      }else{
        this.fileInfoUrl = url;
      }
     
    }
  }


  getBackgroundImageUrl(){
    return 'url('+this.fileInfoUrl+')';
  }

  closeMobileFileInfo(){
    AppEvents.optionSelected.next({fileInfo: false});
    if(this.universalService.inAppWebViewOpened && this.universalService.currentTab == 'fileinfo') {
      this.listService.objectDetails["operationType"] = "fileinfo";
      this.listService.informAndroidAndIOSToCloseWebView("");
    } else if(this.universalService.mobileSelectionModeOn){
      this.universalService.showMobFileInfoPanel = false;
      this.contextMenuMobileService.decideContextMenuItemsForMobile()
    }else{
      this.universalService.showMobFileInfoPanel = false;
      if(this.universalService.showPreview){
        this.contextMenuMobileService.decideContextMenuItemsForMobile();
      } else{
        this.universalService.clearSelection();
      }
      this.universalService.disableModalBackdrop();
    }
  }


  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === "Escape" && !this.universalService.loadManageAccessComponent && this.showFileInfo && !this.universalService.showCoverPicModal) {
      this.universalService.showFileInfo = false;
      this.listService.deSelectAll(event);
      if(this.openSourceComponent != "fileinfo") {
        AppEvents.optionSelected.next({fileInfo: false});
      } else if (this.openSourceComponent == "fileinfo") {
        this.universalService.showModalBackdrop();
      }
    }
  }


  setFileInfoData(){
    var file = this.universalService.selectedFile;
    let isAlbum = false
    if((file["boardKey"] !=undefined || file["boardKey"] !=null) && this.universalService.currentAlbum) {
      isAlbum = true
      if(file["mimeType"]  == "audio" || file["mimeType"]  == "video"){
        this.infoItems = this.universalService.FileInfo["Album_FILE_INFO"]["Media_Charactaristics"]
      }else{
        this.infoItems = this.universalService.FileInfo["Album_FILE_INFO"]["Charactaristics"]
      }
    }else{

      if(file["objectType"] == "FR" || (file["objectType"] == "BR" && file["isBackupDevices"] != "Y")){
        if(file["shareKey"] && file["shareKey"]  != "") {
          this.infoItems = this.universalService.FileInfo["FOLDER_INFO"]["Share_Characteristics"]
        } else {
          this.infoItems = this.universalService.FileInfo["FOLDER_INFO"]["Charactaristics"]
        }
      }else if(file["isBackupDevices"] == "Y"){
        this.universalService.selectedFile["objectKind"] = 'Folder'
        this.infoItems = this.universalService.FileInfo["BACKUP_DEVICE"]["Charactaristics"]
      }else {
        if((file["shareKey"] && file["shareKey"]  != "") && (file["mimeType"]  == "audio" || file["mimeType"]  == "video")){
          this.infoItems = this.universalService.FileInfo["FILE_INFO"]["Share_Media_Characteristics"]
          // if(this.universalService.inAppWebViewOpened) {
          //   this.infoItems = this.infoItems.filter(item => (item.title != "Duration"));  
          // }
        } else if(file["mimeType"]  == "audio" || file["mimeType"]  == "video"){
          this.infoItems = this.universalService.FileInfo["FILE_INFO"]["Media_Charactaristics"]
        } else if(file["shareKey"] && file["shareKey"]  != ""){
          this.infoItems = this.universalService.FileInfo["FILE_INFO"]["Share_Characteristics"]
        } else{
          this.infoItems = this.universalService.FileInfo["FILE_INFO"]["Charactaristics"]
        }
      }
    }
    
    if(isAlbum){
      file =  this.universalService.selectedFile;
    }else if( (!this.universalService.listView || this.universalService.isMobileDevice)&& this.universalService.selectedFile["objectType"]=='FR' || this.universalService.selectedFile["objectType"]=='BR'){
      let  foldersArray = this.universalService.foldersArray
      var find = foldersArray.find(obj=>obj["objectKey"] == this.universalService.selectedFile["objectKey"]);
      if(find){
        file = find; 
        file["objectKind"]= this.universalService.selectedFile["objectKind"];
      }
    }

    this.decideItemsOfInfo(file,isAlbum);
    this.navigateFileInfoTabs('Details');
  }
  formatDate(utcSeconds){
    var date;
    var d = new Date();
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    date = d.getDate() + " " + months[d.getMonth()] + " " + d.getFullYear()
    return date;
  }
  backupDeviceDateFormat(file){
    if(file?.isBackupDevices == 'Y'){
      
      
      // this.universalService.selectedFile["backupDeviceCreatedDate"] = this.universalService.selectedFile["backupDeviceCreatedDate"]?this.universalService.selectedFile["backupDeviceCreatedDate"]:"-";
      // this.universalService.selectedFile["backupDeviceModifiedDate"] = this.universalService.selectedFile["backupDeviceModifiedDate"]?this.universalService.selectedFile["backupDeviceModifiedDate"]:"-"
      file["backupDeviceCreatedDate"]= (file["createdDate"] != "-")?this.formatDate(file["backupDeviceCreatedDate"]):"-";
      file["backupDeviceModifiedDate"] = (file["lastUpdatedDate"] != "-")?this.formatDate(file["backupDeviceModifiedDate"]):"-";
    }
  }

  async decideItemsOfInfo(file,isAlbum){
    await this.backupDeviceDateFormat(file)
    if(isAlbum){
      this.infoItems.map(item=>{
        switch(item.title){
          case "Name": 
            item["value"] = file["objectName"];
            break;
          case "Size":
            item["value"] = file["objectSize"];
            break;
          case "Kind":
            item["value"] = file["objectKind"];
            break;
          case "Created On":
            item["value"] = file["createdOn"];
            break;
          case "Modified On":
            item["value"] = file["modifiedOn"];
            break;
          case "Duration":
            item["value"] = this.universalService.millisToHourMinutesAndSeconds(file["duration"]);
            break;
          case "Owner":
            if(file.isLoggedInUsrFileOwner){
              item["value"] = "You"
            }else{
              item["value"] = ((file["owner"]["ownerFirstName"]) ? file["owner"]["ownerFirstName"] : '') + " " + ((file["owner"]["ownerLastName"]) ? file["owner"]["ownerLastName"] : '');
            }
          default:
            this.loggerService.log("option not found");
        } 
      })
      setTimeout(()=>{
        var classRef = this;
        this.setInfoItemcontHeight();
        $(window).resize(function(){
          classRef.setInfoItemcontHeight();
        });
      },200);
    }else if(!isAlbum && file.isBackupDevices != 'Y'){
      let index=-1;
      let removeIndex = [];
      this.infoItems.map(item=>{
        index++;
        switch(item.title){ 
          case "Name": 
            item["value"] = file["objectName"];
            break;
          case "Size":
            item["value"] = file["objectSize"];
            break;
          case "Kind":
            item["value"] = file["objectKind"];
            break;
          case "Where":
            if(this.globalService.getFolderServiceRef().currentFolderName.length>0){
              item["value"] = this.globalService.getFolderServiceRef().currentFolderName;
            }else{
              item["value"] = "All Files"; // needs to be modified after the server adds parentObjectName in the metadata
            }
            break;
          case "Created On":
            if(file["createdOn"] == "-"){
              removeIndex.push(index)
            }else{
              item["value"] = file["createdOn"];
            }
            break;
          case "Modified On":
            if(window.location.href.includes("?u") || file["modifiedOn"] == "-" || file["modifiedLessThanUploadedDate"] == "true"){
              removeIndex.push(index)
            }else{
              item["value"] = file["modifiedOn"];
            }
            break;
          case "Uploaded On":
            if( window.location.href.includes("?u") || file["uploadedDate"] == "-"){
              removeIndex.push(index)
            }else{
              item["value"] = file["uploadedDate"];
            }
            break;
          case "Duration":
            item["value"] = file["ObjectDuration"];
            break;
          case "Owner":
            if(this.universalService.inAppWebViewOpened && (file["ownerFullName"]  != undefined && file["ownerFullName"]  != "")) {
              item["value"] = file["ownerFullName"] 
            } else {
              // var url = window.location.href;
              // if (url.includes("/shared") && file["objectShareBy"]) {
                
              if (file["shareKey"] && file["shareKey"] != "" && file["objectShareBy"] && file["objectShareBy"]["firstName"]) {
                item["value"] = ((file["objectShareBy"]["firstName"]) ? file["objectShareBy"]["firstName"] : '') + " " + ((file["objectShareBy"]["lastName"]) ? file["objectShareBy"]["lastName"] : '');
              } else {
                item["value"] = ((USER_DETAILS["USER_DETAILS"]["firstName"]) ? USER_DETAILS["USER_DETAILS"]["firstName"] : '') + " " + ((USER_DETAILS["USER_DETAILS"]["lastName"]) ? USER_DETAILS["USER_DETAILS"]["lastName"] : '');
              }
            }
            break;
          default:
            this.loggerService.log("option not found");
        } 
      })
      if(removeIndex.length > 0){
        for (let i = removeIndex.length; i > 0; ) {
          this.infoItems.splice(removeIndex[--i], 1);
        }
       
      }
      setTimeout(()=>{
        var classRef = this;
        this.setInfoItemcontHeight();
        $(window).resize(function(){
          classRef.setInfoItemcontHeight();
        });
      },100);
    }else if(file?.isBackupDevices == 'Y'){
      this.infoItems.map(item=>{
        switch(item.title){
          case "Backup Device Name": 
            item["value"] = file["objectName"];
          break;
          case "Kind":
            item["value"] = file["objectKind"];
            break;
          case "Created On":
              item["value"] = file["backupDeviceCreatedDate"];
            break;
          case "Modified On":
            item["value"] = file["backupDeviceModifiedDate"];
            break;
          default:
            this.loggerService.log("option not found");
        }
      });
    }
  }
  
  showMore(){    
    this.renderer.listen('document', 'click',(e:Event)=>{
      this.isEventTriggered = true;
      if(this.universalService.showInfoDetails){
        let el = document.getElementById('sc_Description') as any;
        let target = e.target as Element
        if(target.classList.contains('showMoreLessBtn')){
          e.stopPropagation();
          if(target.innerHTML == 'show more'){
            el.classList.remove('showLessData')
            el.classList.add('showMoreData')
            target.innerHTML = 'show less'
          }else{
            el.classList.remove('showMoreData')
            el.classList.add('showLessData')
            target.innerHTML = 'show more'
          }
        }
      }
    });
  }

  setInfoItemcontHeight(){
    let header_ele = document.getElementById('desk-info-header');
    let img_ele = document.getElementById('desk-info-img-wrapper');
    let nav_height = document.querySelector('.slidemenu-file-info') as any;
    let info_cont = (document.querySelector('.file-info-scrollable')) as any;
    let height;
    if(this.universalService.isMobileDevice) {
      height = (window.innerHeight- (header_ele.offsetHeight + (nav_height ? nav_height.offsetHeight : 0) + 45)).toString() + 'px';
    } else {
      if(this.router.url.includes('/albums/')) {
        height = (window.innerHeight- (header_ele.offsetHeight + img_ele.offsetHeight + 10)).toString() + 'px';
      } else {
        height = (window.innerHeight- (header_ele.offsetHeight + img_ele.offsetHeight + (nav_height ? nav_height.offsetHeight + 20 : 0) )).toString() + 'px';
      }
      
    }   
    //if(!this.router.url.includes('/albums/')) {
      info_cont.style.height = height
    //} 
    
    // COMMENTED THE FILE INFO CHANGES OF BUILD1 AS FILE INFO IS DIFFERENT FOR ENHANCED SHARE
    // if(!this.universalService.isMobileDevice){
    //   let header_ele = document.getElementById('desk-info-header');
    //   let img_ele = document.getElementById('desk-info-img-wrapper');
    //   let info_cont = (document.querySelector('.img-info-details')) as any;
    //   let height = (window.innerHeight- (header_ele.offsetHeight + img_ele.offsetHeight)).toString() + 'px';
    //   info_cont.style.height = height
    // }else{
    //   let header_ele = document.getElementById('mobIfoHeader');
    //   let info_cont = (document.querySelector('.img-info-details')) as any;
    //   let height = (window.innerHeight- header_ele.offsetHeight).toString() + 'px';
    //   info_cont.style.height = height;
    // }
  }

  editFileName(){
    setTimeout(()=>{
      let el = document.querySelector('#file_info_rename') as any
      el.focus();
      el.click();
    },1000)
    if(this.universalService.selectedFile.hasOwnProperty('editName')){
      this.universalService.selectedFile["editName"] = !this.universalService.selectedFile["editName"];
    } else {
      this.universalService.selectedFile["editName"] = true;
      this.editKeyPressCount=0
    }

    let currentName = "";
    const isFile =  this.universalService.selectedFile["objectType"]=="FR" || this.universalService.selectedFile["objectType"]=="BR"? false : true; 
    if(isFile){
      const file = this.universalService.selectedFile["objectName"];
      const fileExtension =  "."+ file.substring(file.lastIndexOf('.') + 1);
      const fileName = file.split('.').slice(0, -1).join('.');
      this.fileName.setValue(fileName);
      this.fileExtn.setValue(fileExtension);
      //Rename value in case of inapp web view
      this.listService.fileInfoRenameValue = file;
    } else {
      this.fileName.setValue(this.universalService.selectedFile["objectName"]);
      //Rename value required in case of inapp web view
      this.listService.fileInfoRenameValue = this.universalService.selectedFile["objectName"];
    }
   
  
  }

  closeFileNameEditMode(event){
    // this.universalService.selectedFile["editName"]  = false;
  }

  newNameValidation(){
 
    var regex =  /[/\/\\/<>:"|?*]/;
    if(this.fileName.value == "" || this.fileName.value.trim().length == 0){
      this.enableButton = false;
      this.renameError = "Please enter a name."
    } else if(this.fileName.value.match(regex)){
      this.enableButton = false;
      this.renameError = "Please enter a name without / \\ < > : \" | ? *"
    } else if(this.fileName.value.charAt(this.fileName.value.length-1) == '.' && this.universalService.selectedFile["objectType"] == 'FR' || this.universalService.selectedFile["objectType"] == 'BR'){
      this.enableButton = false;
      this.renameError = "Folder name cannot end with ' . '"
    } else if(!(this.fileName.value.match(regex))){
      this.enableButton  = true;
      this.renameError = "";  
    }
  }

  keyPressCount(event){
    this.editKeyPressCount++;
  }

  async renameFile(){
  
    this.newNameValidation();

    if(this.enableButton == false && this.renameError){
      return;
    }
    
    this.universalService.selectedFileOldName = this.universalService.selectedFile["objectName"];
    
    if(this.universalService.selectedFile["objectName"] === (this.universalService.selectedFile["objectType"] == 'FR' ? this.fileName.value.trim() : this.fileName.value.trim() + ( this.fileExtn.value.includes('.') ? this.fileExtn.value : "." + this.fileExtn.value))) {
      if(this.universalService.selectedFile.hasOwnProperty('editName')){
        this.universalService.selectedFile["editName"] = !this.universalService.selectedFile["editName"];
      } else {
        this.universalService.selectedFile["editName"] = true;
        this.editKeyPressCount=0
      }
      return;
    } 
    this.universalService.selectedFile["objectName"] =  this.universalService.selectedFile["objectType"] == 'FR' ? this.fileName.value.trim() : this.fileName.value.trim() + ( this.fileExtn.value.includes('.') ? this.fileExtn.value : "." + this.fileExtn.value);
    //const userId = USER_DETAILS["USER_DETAILS"]["rootFolderKey"] ? USER_DETAILS["USER_DETAILS"]["rootFolderKey"] : this.localStorageSvc.getUserId(true);
    const userId = USER_DETAILS["USER_DETAILS"]["userId"];
    var Obj = {
      "files":this.universalService.selectedFile,
      "operation":"RENAME",
      "correlationId": userId
    }
    if(this.universalService.selectedNodes.length == 0) {
      this.universalService.selectedNodes[0] = this.universalService.selectedFile;
    }
    
    this.fileRenamed.emit(Obj);
    //this.closeNav();
    this.editFileName();

    // try {
    //   let result = await this.fileOperationsCntlr.performSelectedOperation(Obj.files, Obj.operation, Obj.correlationId);
    //   if(result["status"] == "success"){ 
    //     this.fileRenamed.emit(result["executed operation"])
    //     // this.fileOperationsCntlr.actionCompletedSuccessfully(result["executed operation"]);

    //   }
    //   this.closeNav();
    // } catch(error){
    //   this.closeNav();
    // }
    

    
  }

  switchFileInfoTab(tabName) {
   
  }

  /**
   * @param tabName 
   * Method to navigate file info tabs based on input tab name 
   */
  navigateFileInfoTabs(tabName) {

    if(tabName == "Details"){ // Details tab
      this.showFileInfoDetails();
      this.setInfoItemcontHeight();
    } else if(tabName == "Activity"){ // Activity tab
      this.showFileInfoActivity();

    } else if(tabName == "Comments"){  // Comments tab
      this.showFileInfoComments();
    }
  }

  async showFileInfoDetails() {
    this.universalService.showInfoDetails = false;
    this.universalService.showInfoActivity = false;
    this.universalService.showInfoComments = false;
    //Set details active
    jQuery("#fileinfo-item-1").prop("checked", true);
    jQuery('#fileinfo-item-1').addClass('active');

    if(this.publicLinknotLoggedIn){
      this.universalService.showInfoDetails = true;
    }else if(this.universalService.selectedFile && this.universalService.selectedFile.shareKey && this.universalService.selectedFile.shareKey != "") {      
       // If share key exist, then show shared file details
      this.universalService.showInfoDetails = true;
      this.shareObjectsImplementation.toggleSmallLoader(true);
      var membersList = await this.fileInfoController.getSharedFileMembers(this.universalService.selectedFile.shareKey);
      if(membersList != null) {
        this.shareObjectsImplementation.setMembersLink(membersList);
      }
      this.shareObjectsImplementation.toggleSmallLoader(false);
    } else {
      this.universalService.showInfoDetails = true;
    }
  }

  showFileInfoActivity() {
    //Set details active
    var self = this;
    this.universalService.showInfoActivity = true;
    setTimeout(function() {
      self.universalService.showInfoComments = false;
      self.universalService.showInfoDetails = false;
    });
    jQuery('#fileinfo-item-2').addClass('active');
  }

  showFileInfoComments() {
    var self = this;
    this.universalService.showInfoComments = true;
    setTimeout(function() {
      self.universalService.showInfoActivity = false;
      self.universalService.showInfoDetails = false;
    });
  }

  openManageAccessView() {
    //this.universalService.showManageAccess = true;
    /*if(this.shareObjectsImplementation.sharedFileRecipientsList.length > 0) {
      this.universalService.loadManageAccessComponent = true;
      jQuery(".manage-access-panel").fadeIn();
    }*/
    if(this.shareObjectsImplementation.sharedFileRecipientsList.length > 0) {
      this.universalService.showShareWithPeople = true;
      this.universalService.showFileInfo = false;
      AppEvents.optionSelected.next({shareWithPeople: true, openSource: "fileinfo"});
    }
  }

  checkIfUserIsLoggedIn(){
    var userData = this.localStorageService.getUserData(true);
    var nativeHeaders = this.localStorageService.getNativeHeaders('nativeHeaders');
		if (userData) {
      const rootFolderKey = userData["rootFolderKey"];
        this.universalService.userLoggedIn = true;
        AppEvents.updateAuthData.next({"updateAuthData":true,userData:userData});
		}else if (nativeHeaders){
      this.universalService.userLoggedIn = true;
      this.universalService.inAppWebViewOpened = true;
    } else {
		  this.universalService.userLoggedIn = false;
		}
  }

  async getPPFToken(){
    await this.listService.getPPFToken();
    this.ppfToken = encodeURIComponent(this.universalService.header_X_PPF_TOKEN)
  }
}
